import React, { useState } from "react";
import {
  Box,
  Button,
  IconButton,
  InputBase,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Typography,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import styles from "./style";
import CustomPagination from "../../../../../../components/CustomPagination";
import SortBy from "../../../../../../components/SortBy";
import { Search } from "@mui/icons-material";

const AssetsHomePage = ({
  assetsData,
  total,
  currentPage,
  setCurrentPage,
  rowsPerPage,
  setRowsPerPage,
}) => {
  const navigate = useNavigate();

  const handleViewAsset = (item) => {
    navigate("/dashboard/assetsHome/assetsView", { state: { item } });
  };
  
  return (
    <>
      <Box px="20px" mt={2}>
        <Box sx={styles.header}>
          <Typography sx={styles.headerText}>All Assets</Typography>
          <Button
            variant="contained"
            color="primary"
            onClick={() => navigate("assetsCreate")}
            sx={styles.addButton}
          >
            Add New
          </Button>
        </Box>
      </Box>
      <Box sx={styles.container}>
        <Box sx={styles.filterSection}>
          <Box sx={styles.searchContainer}>
            <Box
              borderRadius="30px"
              backgroundColor="#F5F5F5"
              width="20%"
              marginRight={{ xs: 0, md: "5px" }}
              justifyContent="center"
              marginBottom={{ xs: "20px", md: 0 }}
            >
              <IconButton type="button" sx={{ p: 1 }}>
                <Search />
              </IconButton>
              <InputBase sx={{ flex: 1, fontSize: "12px" }} placeholder="Search" />
            </Box>
          </Box>
          <Box sx={styles.sortByContainer}>
            <SortBy handleSort={""} />
          </Box>
        </Box>

        <TableContainer>
          <Table>
            <TableHead>
              <TableRow>
                <TableCell sx={styles.tableCell}>Asset Name</TableCell>
                <TableCell sx={styles.tableCell}>Asset Number</TableCell>
                <TableCell sx={styles.tableCell}>Asset Type</TableCell>
                <TableCell sx={styles.tableCell}>Purchase Price </TableCell>
                <TableCell sx={styles.tableCell}>Status</TableCell>
                <TableCell sx={styles.tableCell}>Current Value</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {assetsData.length === 0
                ? (
                  <TableRow>
                    <TableCell colSpan={8} align="center">
                      <Typography variant="h6">No Data</Typography>
                    </TableCell>
                  </TableRow>
                )
                : (
                  assetsData.map((row) => (
                    <TableRow key={row._id} onClick={() => { handleViewAsset(row) }} sx={{ cursor: "pointer" }}>
                      <TableCell sx={styles.tableCells}>
                        {row?.assetName || "N/A"}
                      </TableCell>
                      <TableCell sx={styles.tableCells}>
                        {row?.assetNo || "N/A"}
                      </TableCell>
                      <TableCell sx={styles.tableCells}>
                        {row?.assetType || "N/A"}
                      </TableCell>
                      <TableCell >
                        {row?.purchaseValue || "N/A"}
                      </TableCell>
                      <TableCell sx={styles.statusCell}>
                        <Typography>{row?.status || "N/A"}</Typography>
                      </TableCell>
                      <TableCell sx={styles.tableCells}>
                        {row.currentValue ?? "N/A"}
                      </TableCell>
                    </TableRow>
                  ))
                )}
            </TableBody>
          </Table>
          <CustomPagination
            pageCount={total}
            totalItems={total}
            page={currentPage}
            setPage={setCurrentPage}
            rowsPerPage={rowsPerPage}
            setRowsPerPage={setRowsPerPage}
          />
        </TableContainer>
      </Box>
    </>
  );
};

export default AssetsHomePage;
